import { Environment } from 'dashboard/models/environment';
import Action from 'lib/interfaces/Action';

interface CurrentEnvironmentPayload {
  environment: Environment;
}

export type CurrentEnvironmentActions = Action<
  CurrentEnvironmentActionType.SetCurrentEnvironment,
  CurrentEnvironmentPayload
>;

export enum CurrentEnvironmentActionType {
  SetCurrentEnvironment = 'current-environment/SET_CURRENT_ENVIRONMENT',
}
export function setCurrentEnvironment(environment: Environment) {
  return {
    payload: {
      environment,
    },
    type: CurrentEnvironmentActionType.SetCurrentEnvironment,
  };
}
